import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-business-card',
  templateUrl: './section-business-card.component.html',
  styleUrls: ['./section-business-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionBusinessCardComponent {}
